// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"40":"component---src-components-pages-home-home-tsx","218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"40":"753b51aca556e6892775","218":"a6c497cc1545941aa722","351":"58ef2bf2381f88fec785","691":"892d6c5347d66a60354f"}[chunkId] + ".js";
};